<script lang="ts" setup>
  import NavigationMobile from '@/components/layout/NavigationMobile.vue'
  import HeaderHistoryBar from '@/components/layout/HeaderHistoryBar.vue'
  import HeaderComponent from '@/components/layout/HeaderComponent.vue'

  const searchScopes: string[] = []
  const searchUrl = ''
</script>

<template>
  <HeaderComponent
    :search-scopes="searchScopes"
    :search-url="searchUrl"
    class="z-40 h-26 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white dark:bg-black dark:border-gray-800 shadow-sm p-1 md:gap-x-6 md:px-6" />
  <HeaderHistoryBar v-if="$titrop.config.user('exp_history_bar', false).value" />
<!--  <NavigationMobile class="md:hidden" />-->
</template>

<style scoped></style>
